/**
 * Genereate result data
 *
 * @param {string} data
 */
export const GetResultsFromData = (
  data,
  reason,
  courtID = "",
  ResultString = ""
) => {
  // if (courtID == 3 || courtID == 1 || courtID == 2) return;

  if (!data) return;

  // const dataObj = Object.entries(data).map((k) => ({ [k[0]]: k[1] }));
  // console.log(dataObj);

  const createResults = (data) => {
    const rowPlayerA = [];
    const rowPlayerB = [];

    // const dataObj = Object.entries(data).map((k) => ({ [k[0]]: k[1] }));
    // console.log("ResultString", courtID, ResultString);
    // console.log(dataObj);

    // add index to for in loop
    let i = 0;
    for (const key in data) {
      // const curentScore = Object.keys(data)[i];

      // if (data[key] !== "") {
      // console.log(i);

      // if data data[key] has A then push to rowPlayerA
      if (key.includes("A") && !key.includes("ScoreTB") && data[key] !== "") {
        rowPlayerA.push(+data[key]);
      }

      // if data data[key] has B then push to rowPlayerB not TB
      if (key.includes("B") && !key.includes("ScoreTB") && data[key] !== "") {
        rowPlayerB.push(+data[key]);
      }

      // if kayy incliude ScoreTB string
      if (key.includes("ScoreTB") && data[key] !== "") {
        const curentScore = Object.keys(data)[i];
        // console.log(curentScore, data[curentScore]);

        if (curentScore.includes("A")) {
          const lastElement = rowPlayerA.pop();
          rowPlayerA.push(`${lastElement}<sup>${data[curentScore]}</sup>`);
        }

        if (curentScore.includes("B")) {
          const lastElement = rowPlayerB.pop();
          rowPlayerB.push(`${lastElement}<sup>${data[curentScore]}</sup>`);
        }
      }
      i += 1;
    }

    if (reason) {
      rowPlayerB.push(reason);
    }

    // console.log(rowPlayerA, rowPlayerB);
    return { rowPlayerA, rowPlayerB };
  };

  const results = createResults(data);

  // results for player A generate div with class tennis-results-top
  const resultsA = results.rowPlayerA
    .map((score, index) => {
      return `<div class="col-3">${score}</div>`;
    })
    .join("");

  const resultsB = results.rowPlayerB
    .map((score, index) => {
      // if score is string and not html tag
      if (typeof score === "string" && !score.includes("<")) {
        return `<div class="col-3 score-text-small">${score}</div>`;
      } else {
        return `<div class="col-3">${score}</div>`;
      }
    })
    .join("");

  // console.log(resultsA, resultsB);

  return `
    <div class="row">${resultsA}</div>
    <div class="row">${resultsB}</div>`;
};
